<template>
    <aside class="lc-emoji-picker">
        <picker v-show="isOpen"
                title='Pick your emoji…'
                emoji='point_up'
                set="apple"
                :background-image-fn="onBackgroundImageFn"
                @select="$emit('select', $event)"
                ></picker>
    </aside>
</template>
<script>
import { Picker } from 'emoji-mart-vue'
import Toggle from '../../../mixins/toggle.js'

export default {
    mixins: [Toggle],

    methods: {
        onBackgroundImageFn () {
            return '/images/emojis/sheet_apple_64_indexed_256.png'
        }
    },

    components: {
        Picker
    }
}
</script>
